<template>
    <div :class="['content-wrap',$mq]">
        <mq-layout mq="mobile">
            <MobileFrame
                :menu-type="getMenuType()"
                :submenu-type="submenu"
                :get-sub-menu="getSubmenu()"
            ></MobileFrame>
        </mq-layout>
        <mq-layout mq="laptop+">
            <LaptopFrame :menu-type="getMenuType()" :submenu-type="submenu"></LaptopFrame>
        </mq-layout>
    </div>
</template>
<script>
import MobileFrame from "./CurriculumMobile";
import LaptopFrame from "./CurriculumLaptop";

export default {
    name: "Curriculum",
    components: { MobileFrame, LaptopFrame },
    props: ["menu", "submenu"],
    created() {},
    data() {
        return {};
    },
    methods: {
        getMenuType() {
            let url = (this.menu = this.menu ? this.menu : "guide");
            return url;
        },
        getSubmenu() {
            return this.submenu;
        }
    },

    watch: {
        $route(to, from) {
            if (to.path == "/curriculum/missions") {
                this.$router.go("/curriculum/missions/prekinder");
            }
            if (to.path == "/curriculum/games") {
                this.$router.go("/curriculum/games/countingandcardinality");
            }
            if (to.fullPath != from.fullPath) {
                window.scrollTo(0, 0);
            }
        }
    }
};
</script>
<style  scoped>
.content-wrap {
    position: relative;
    min-width: 100%;
}
.content-wrap.mobile {
    width: 720px;
}
.content-wrap.laptop {
    width: 1024px;
}
</style>

<style>
.curriculum-title1 {
    font-size: 52px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.14;
    letter-spacing: -2px;
    color: #41403e;
}
.curriculum-title2 {
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: -1px;
    color: #41403e;
}
.curriculum-title3 {
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.45;
    letter-spacing: -0.8px;
    color: #41403e;
}
.curriculum-description {
    font-size: 22px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.45;
    letter-spacing: -0.8px;
    color: #41403e;
}
.curriculum-description.list {
    position: relative;
    padding-left: 17px;
}
.curriculum-description.list::before {
    content: url("../../assets/curriculum/icon-text-el-grey.svg");
    position: absolute;
    left: 0;
    line-height: 0.8;
    transform: scale(0.5) translateY(50%);
}

.mobile .curriculum-title1 {
    font-size: 64px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: -2.5px;
    color: #41403e;
}
.mobile .curriculum-title2 {
    font-size: 34px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.35;
    letter-spacing: -1px;
    color: #41403e;
}
.mobile .curriculum-title3 {
    font-size: 28px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.36;
    letter-spacing: -1px;
    color: #41403e;
}
.mobile .curriculum-description {
    font-size: 28px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.36;
    letter-spacing: -1px;
    color: #41403e;
}
.mobile .curriculum-description.list {
    position: relative;
    padding-left: 15px;
}
.mobile .curriculum-description.list::before {
    content: url("../../assets/curriculum/icon-text-el-grey.svg");
    position: absolute;
    left: 0;
    line-height: 0.8;
    transform: scale(0.5) translateY(50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/curriculum/Curriculum.vue